export const UPDATE_ROOM_ERROR_MESSAGE = "Error updating room";
export const UPDATE_ROOM_SALESFORCE_ERROR_MESSAGE = "Error updating room in Salesforce";
export const ROOM_NOT_FOUND_ERROR_MESSAGE = "Room not found";
